function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import cx from 'clsx';
import PropTypes from 'prop-types';
import * as React from 'react';
import { childrenUtils, customPropTypes, getComponentType, getUnhandledProps, getKeyOnly } from '../../lib';

/**
 * A dimmable sub-component for Dimmer.
 */
var DimmerDimmable = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var blurring = props.blurring,
    className = props.className,
    children = props.children,
    content = props.content,
    dimmed = props.dimmed;
  var classes = cx(getKeyOnly(blurring, 'blurring'), getKeyOnly(dimmed, 'dimmed'), 'dimmable', className);
  var rest = getUnhandledProps(DimmerDimmable, props);
  var ElementType = getComponentType(props);
  return /*#__PURE__*/React.createElement(ElementType, _extends({}, rest, {
    className: classes,
    ref: ref
  }), childrenUtils.isNil(children) ? content : children);
});
DimmerDimmable.displayName = 'DimmerDimmable';
DimmerDimmable.propTypes = {
  /** An element type to render as (string or function). */
  as: PropTypes.elementType,
  /** A dimmable element can blur its contents. */
  blurring: PropTypes.bool,
  /** Primary content. */
  children: PropTypes.node,
  /** Additional classes. */
  className: PropTypes.string,
  /** Shorthand for primary content. */
  content: customPropTypes.contentShorthand,
  /** Controls whether or not the dim is displayed. */
  dimmed: PropTypes.bool
};
export default DimmerDimmable;
//# sourceMappingURL=DimmerDimmable.js.map